import React, { FormEvent, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'types/store';
import { VehicleType } from 'types/common/vehicles';
import useVehicleSearch from 'hooks/journeys/loyaltyRewards/useVehicleSearch';
import ModalForm from './ModalForm';
import SingleInputSearch from './SingleInputSearch';

interface SearchCardProps {
  isVehicleModalOpen: boolean,
  toggleVehicleModal: React.Dispatch<React.SetStateAction<boolean>>,
}

const SearchCard: React.FC<SearchCardProps> = ({
  isVehicleModalOpen,
  toggleVehicleModal,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const vehicles = useSelector((state: Store) => state.journeys.loyaltyRewards.vehicles);

  const {
    loading,
    formState,
    inputValues,
    handleInputChange,
    findVehicle,
    saveVehicle,
  } = useVehicleSearch(toggleVehicleModal);

  useEffect(() => {
    if (isVehicleModalOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isVehicleModalOpen]);

  const handleFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const regNo = new FormData(event.currentTarget).get('regNo') as string;
    if (regNo) findVehicle(regNo);
  };

  const handleModalSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const vehicleToSave: VehicleType = {
      registration: inputValues.Registration.toUpperCase(),
      yearOfManufacture: parseInt(inputValues.YearOfManufacture),
      make: inputValues.Make,
      model: inputValues.Model,
      transmission: inputValues.Transmission,
      fuelType: inputValues.FuelType,
    };
    saveVehicle(vehicleToSave);
  };

  return (
    <div>
      {vehicles.length === 0 && (
        <SingleInputSearch
          loading={loading}
          onSubmit={handleFormSubmit}
        />
      )}
      {isVehicleModalOpen && (
        <ModalForm
          loading={loading}
          error={formState.error}
          inputValues={inputValues}
          inputChangeHandler={handleInputChange}
          onSubmit={handleModalSubmit}
          onSearch={() => findVehicle(inputValues.Registration)}
          onClose={() => toggleVehicleModal(false)}
          validateNumericEntry={(event) => {
            if (!/[0-9]/.test(event.key)) event.preventDefault();
          }}
          inputRef={inputRef}
        />
      )}
    </div>
  );
};

export default SearchCard;
